<template>
    <div class="shopping-cart" v-loading="loading">
        <template v-if="summary">
            <h3 class="mt-0 mb-5 text-center">Order Summary</h3>
            <div class="mt-5" v-for="(item, i) in summary.orders" :key="i">
                <template v-if="item.calendar">
                    <h4 class="mt-0 mb-0">
                        {{ item.calendar.name
                        }}{{ item.calendar.is_weekly ? " Weekly" : "" }}
                        Calendar
                    </h4>
                    <div
                        class="shopping-cart__row"
                        v-for="(size, j) in item.sizes"
                        :key="j"
                    >
                        <div class="cart-left">
                            <b>{{ size.quantity }}</b> - {{ size.name }}
                            <span v-if="size.color_type === ColorTypes.COLORED"
                                >Color</span
                            ><span v-else>Black Ink</span>
                            <span v-if="size.type === SizeTypes.FLAT"
                                >Cop<span v-if="size.quantity > 1">ies</span
                                ><span v-else>y</span></span
                            ><span v-else
                                >Poster<span v-if="size.quantity > 1"
                                    >s</span
                                ></span
                            >
                            <div
                                class="paper-color"
                                title="Paper Color"
                                v-if="size.paper_color && !size.best_judgement"
                                :style="{
                                    'background-color': size.paper_color
                                }"
                            ></div>
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ size.amount | currency }}
                        </div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-for="(file, k) in item.digital_files"
                        :key="k"
                    >
                        <div class="cart-left">
                            {{ file.name }}
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ file.price | currency }}
                        </div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-for="(extra, m) in item.printed_extras"
                        :key="m"
                    >
                        <div class="cart-left">
                            <b>{{ extra.quantity }}</b> - {{ extra.name }}
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ (extra.price * extra.quantity) | currency }}
                        </div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-if="item.birthday_posters.length"
                    >
                        <div class="cart-left">
                            <b>{{ item.birthday_posters.length }}</b> - Birthday
                            Posters
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{
                                (item.birthday_posters.length *
                                    item.birthday_posters[0].price)
                                    | currency
                            }}
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="shopping-cart__row">
                        <div class="cart-left">
                            <b>{{ item.quantity }}</b> - Newsletter
                            <span v-if="item.color_type"
                                >({{
                                    item.color_type === ColorTypes.COLORED
                                        ? "Color"
                                        : "Black"
                                }})</span
                            >
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ item.total_amount | currency }}
                        </div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-for="(file, x) in item.digital_files"
                        :key="x"
                    >
                        <div class="cart-left">
                            {{ file.name }}
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ file.price | currency }}
                        </div>
                    </div>
                </template>
            </div>
            <div class="mt-10"></div>
            <div
                class="shopping-cart__row"
                :class="{ bold: total.bold }"
                v-for="(total, n) in summary.totals"
                :key="n"
            >
                <div class="cart-left">
                    {{ total.label }}
                </div>
                <div class="cart-dots"></div>
                <div class="cart-right">
                    <span v-if="total.loading"
                        ><i class="mdi mdi-loading mdi-spin"></i
                    ></span>
                    <span v-else-if="total.subtract"
                        >({{ total.amount | currency }})</span
                    >
                    <span v-else>{{ total.amount | currency }}</span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import * as ColorTypes from "@/constants/color-types";
import * as Routes from "@/constants/routes";
import * as SizeTypes from "@/constants/size-types";
import OrderUtils from "@/utils/order";

export default {
    props: {
        order: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            Routes,
            ColorTypes,
            SizeTypes,
            orders: [],
            loading: false,
            summary: null
        };
    },
    created() {
        this.getSummary();
    },
    computed: {
        totals() {
            if (!this.summary) {
                return [];
            }
            return OrderUtils.getTotals(this.order, this.summary);
        }
    },
    methods: {
        getSummary() {
            this.loading = true;
            axios
                .get(`/web-api/order/${this.order.id}/summary`)
                .then((response) => {
                    this.summary = response.data;
                })
                .finally(() => (this.loading = false));
        }
    },
    watch: {
        order() {
            this.getSummary();
        }
    }
};
</script>
